// Add commas and decimals to number
export const prettifyNumber = (
  num: string | number,
  decimal: number = 0,
  shortenMillion: boolean = false,
) => {
  const converted = typeof num === 'number' ? num : parseFloat(num);
  if (shortenMillion && converted >= 1000000 && converted < 1000000000) {
    return (
      (converted / 1000000)
        .toFixed(converted % 1000000 === 0 ? 0 : 1)
        .toString() + 'M'
    );
  }
  return converted.toLocaleString(undefined, {
    // Dont show decimals unless its a float
    minimumFractionDigits: Number.isInteger(converted) ? decimal : 2,
    maximumFractionDigits: 2,
  });
};

export const parseAmount = (amount) => {
  const parsed = parseFloat(amount);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const isEqualNumbers = (num1, num2) =>
  parseFloat(num1) === parseFloat(num2);

export const padZero = (value, length = 2) =>
  String(value).padStart(length, '0');

export const toNumber = (val: any) => Number(val);

export const getGst = (price: number): string => {
  const subtotal = price / 1.15;
  return prettifyNumber(price - subtotal);
};

export const shortenNumber = (num: number) => {
  let val = num;
  let suffix = '';

  if (num >= 1000000) {
    val = num / 1000000;
    suffix = 'M';
  } else if (num >= 1000) {
    val = num / 1000;
    suffix = 'K';
  }

  return `${Number.isInteger(val) ? val : val.toFixed(1)}${suffix}`;
};

export const limitNumber = (value: number, limit: number) => {
  if (limit) {
    return R.min(value, limit);
  }
  return value;
};

const GST_RATE = 0.130435;

export const gstCalculator = (amount: string) => {
  const parsed = parseFloat(amount);
  return prettifyNumber(parsed * GST_RATE);
};

export const findRetailPrice = (amount: string) => {
  const parsed = parseFloat(amount);
  return prettifyNumber(parsed - parsed * GST_RATE);
};
